import React, { Component } from "react";

import SP_LWOCrypt from "./SP_LWOCrypt/SP_LWOCrypt"
import InteractionLWOCrypt from "./InteractionLWOCrypt/InteractionLWOCrypt"
import LWOCrypt4 from "./LWOCrypt4";

class Description extends Component {

  constructor() {
    super();
    this.state = {
      blockLWOCrypt4IsOpen: false,
      blockSP_LWOCryptIsOpen: false,
      blockInteractionLWOCryptIsOpen: false,
      blockLddDescriptionIsOpen: false,
      blockOpenVPNDescriptionIsOpen: false,
      blockHaproxyDescriptionIsOpen: false,
    };
    ////
    this.openBlockLWOCrypt4 = this.openBlockLWOCrypt4.bind(this);
    this.closeBlockLWOCrypt4 = this.closeBlockLWOCrypt4.bind(this);

    this.openBlockSP_LWOCrypt = this.openBlockSP_LWOCrypt.bind(this);
    this.closeBlockSP_LWOCrypt = this.closeBlockSP_LWOCrypt.bind(this);

    this.openBlockInteractionLWOCrypt = this.openBlockInteractionLWOCrypt.bind(this);
    this.closeBlockInteractionLWOCrypt = this.closeBlockInteractionLWOCrypt.bind(this);

    this.openBlockLddDescription = this.openBlockLddDescription.bind(this);
    this.closeBlockLddDescription = this.closeBlockLddDescription.bind(this);

    this.openBlockOpenVPNDescription = this.openBlockOpenVPNDescription.bind(this);
    this.closeBlockOpenVPNDescription = this.closeBlockOpenVPNDescription.bind(this);

    this.openBlockHaproxyDescription = this.openBlockHaproxyDescription.bind(this);
    this.closeBlockHaproxyDescription = this.closeBlockHaproxyDescription.bind(this);
  }

  openBlockLWOCrypt4() {
    this.setState({ blockLWOCrypt4IsOpen: true })
  }
  closeBlockLWOCrypt4() {
    this.setState({ blockLWOCrypt4IsOpen: false })
  }

  openBlockSP_LWOCrypt() {
    this.setState({ blockSP_LWOCryptIsOpen: true })
  }
  closeBlockSP_LWOCrypt() {
    this.setState({ blockSP_LWOCryptIsOpen: false })
  }

  openBlockInteractionLWOCrypt() {
    this.setState({ blockInteractionLWOCryptIsOpen: true })
  }
  closeBlockInteractionLWOCrypt() {
    this.setState({ blockInteractionLWOCryptIsOpen: false })
  }

  openBlockLddDescription() {
    this.setState({ blockLddDescriptionIsOpen: true })
  }
  closeBlockLddDescription() {
    this.setState({ blockLddDescriptionIsOpen: false })
  }

  openBlockOpenVPNDescription() {
    this.setState({ blockOpenVPNDescriptionIsOpen: true })
  }
  closeBlockOpenVPNDescription() {
    this.setState({ blockOpenVPNDescriptionIsOpen: false })
  }

  openBlockHaproxyDescription() {
    this.setState({ blockHaproxyDescriptionIsOpen: true })
  }
  closeBlockHaproxyDescription() {
    this.setState({ blockHaproxyDescriptionIsOpen: false })
  }
  render() {
    return (
      <div style={{
        maxWidth: "800px",
        marginTop: '20px',
        textAlign: "justify",
      }}>



        <SP_LWOCrypt
          blockSP_LWOCryptIsOpen={this.state.blockSP_LWOCryptIsOpen}
          openBlockSP_LWOCrypt={this.openBlockSP_LWOCrypt}
          closeBlockSP_LWOCrypt={this.closeBlockSP_LWOCrypt}

        />

        <InteractionLWOCrypt
          blockInteractionLWOCryptIsOpen={this.state.blockInteractionLWOCryptIsOpen}
          openBlockInteractionLWOCrypt={this.openBlockInteractionLWOCrypt}
          closeBlockInteractionLWOCrypt={this.closeBlockInteractionLWOCrypt}

          blockLddDescriptionIsOpen={this.state.blockLddDescriptionIsOpen}
          openBlockLddDescription={this.openBlockLddDescription}
          closeBlockLddDescription={this.closeBlockLddDescription}

          blockOpenVPNDescriptionIsOpen={this.state.blockOpenVPNDescriptionIsOpen}
          openBlockOpenVPNDescription={this.openBlockOpenVPNDescription}
          closeBlockOpenVPNDescription={this.closeBlockOpenVPNDescription}

          blockHaproxyDescriptionIsOpen={this.state.blockHaproxyDescriptionIsOpen}
          openBlockHaproxyDescription={this.openBlockHaproxyDescription}
          closeBlockHaproxyDescription={this.closeBlockHaproxyDescription}

        />

        <LWOCrypt4
          blockLWOCrypt4IsOpen={this.state.blockLWOCrypt4IsOpen}
          openBlockLWOCrypt4={this.openBlockLWOCrypt4}
          closeBlockLWOCrypt4={this.closeBlockLWOCrypt4}
        />


      </div>
    );
  }
}

export default Description;
